import { render, staticRenderFns } from "./UploadStatus.vue?vue&type=template&id=733465ec&scoped=true&"
import script from "./UploadStatus.vue?vue&type=script&lang=js&"
export * from "./UploadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733465ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733465ec')) {
      api.createRecord('733465ec', component.options)
    } else {
      api.reload('733465ec', component.options)
    }
    module.hot.accept("./UploadStatus.vue?vue&type=template&id=733465ec&scoped=true&", function () {
      api.rerender('733465ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/UploadStatus.vue"
export default component.exports